import React from 'react'
import { Link } from 'react-router-dom'
import {Button, Typography}  from '@mui/material';
import { useTranslation } from 'react-i18next';
import Search from './Search';


function TitleLink({
    boxTitle='Title', 
    subTitle='',
    bgColor='#fff',
    enableLink=false,
    linkTitle='View All', 
    link='/',
    
    enableButton=false,
    buttonTitle='Add', 
    onClick='/',
    startIcon=false,
    show=false,
    
    enabledSearch=false,
    searchComponent=''
    }) {
      
  const {t} = useTranslation('global');

  return (
    <div style={{display:'flex', justifyContent:'space-between', padding:'10px', borderRadius:'5px', backgroundColor:`${bgColor}`}}>
        <div className='title-link-left'>
          {boxTitle}
          {subTitle && <span  style={{marginLeft:'10px',fontSize:'10px',marginTop:'5px', textAlign:'center'}}>
            {subTitle}</span>}
        </div>
       
        <div className='title-link-right'>
          {enabledSearch && searchComponent}   
          {enableLink &&    
            <Link style={{ color: '#028FD7', textDecoration: 'none'}} to={link}>{linkTitle}</Link>
          }
          {enableButton && 
            <Button sx={{textTransform:"none", borderRadius:"15px"}} 
              size="small" 
              onClick={onClick} 
              variant="contained" 
              startIcon={startIcon}>
                {show ? t('cancel'): buttonTitle}
            </Button>
          }
        </div>
    </div>
  )
}

export default TitleLink